import { useNavigate } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
const { Header, Body, Footer, Title, Text } = Card;

export default function ErrorScreen({ removeError, text }) {
    const navigate = useNavigate()
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center" >
            <Card>
                <Header className="bg-warning">
                    Something Broke
                </Header>
                <Body>
                    <Title>
                        This is why we can't have nice things.
                    </Title>
                    <Text className="text-center">
                        {text}
                    </Text>
                </Body>
                <Footer className="d-flex justify-content-end">
                    <Button variant="outline-warning" className="px-5" onClick={() => {
                        removeError()
                        navigate('/') //when put inside LinkContainer, was screwing up BS outline-warning style
                    }}>
                        <i className="fa fa-home me-3"></i>
                        Go Home
                    </Button>
                </Footer>
            </Card>
        </ div>
    )
}